import { DepartmentsSelect } from '../Selects';

import { useDepartmentStore } from '@/stores/department';

export const Departments = () => {
  const selected = useDepartmentStore((state) => state.selected);
  const select = useDepartmentStore((state) => state.select);

  return <DepartmentsSelect value={selected} onSelect={select} />;
};
